<template>
    <div class="container">
        <div class="row pt-10 pb-5 text-left container-content">
            <div class="breadcrum">
                <a
                    class="link"
                    href="https://financialdataexchange.org/FDX/FDX/Default.aspx?hkey=bd839735-ebf5-426a-91f9-8334cbae1438"
                    >Home</a
                ><a>&nbsp;»&nbsp;</a>
                <a
                    class="link"
                    href="https://financialdataexchange.org/FDX/FDX/Membership/Benefits.aspx?hkey=3537db1b-f8eb-4c56-aeac-b492c89a2318"
                    >Membership</a
                ><a>&nbsp;»&nbsp; {{ $route.name }} </a>
            </div>
            <h4 class="heading">Get Started with FDX Today!</h4>
            <p class="para1" style="border: 1px solid #019382">
                If your organization is already a member of FDX please use
                existing member registration.<button
                    type="button"
                    class="btn btn-default btn1"
                    @click="
                        $router.push({
                            name: 'AccountViewOrganization',
                            query: { from: 'startPage' },
                        })
                    "
                >
                    EXISTING MEMBER REGISTRATION
                </button>
            </p>
            <p style="color: #019382"><strong>Registration Options</strong></p>
            <hr />
            <div class="box">
                <div class="box-head">Member</div>
                <div class="para1">
                    For organizations wishing to participate as a full FDX
                    member – joining over 200 other financial industry
                    stakeholders in developing, expanding and growing adoption
                    of FDX technical standards through collaborate work.
                </div>
                <div class="box-body">
                    <div class="row">
                        <div class="col-sm-6 divide-line">
                            <p><strong>What’s Included</strong></p>
                            • Access to FDX API<br />
                            • Access to FDX material/documentation<br />
                            • Unlimited Users<br />
                            • Dedicated Registry Listing<br />
                            • Registry Viewing<br />
                            • Implementation Guides<br />
                            • Unlimited Participation in FDX working groups and
                            task forces<br />
                            • Equal voting rights on FDX API<br />
                            • Discounted access to FDX Global Summits<br />
                            • Member Exclusive Webinars, Content& Events<br />
                            • Discounted FDX API Certification<br />
                            • Collaborate with industry peers in FDX working
                            groups and task forces
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Cost</strong></p>
                            <p>Revenue-Based Annual Dues**</p>
                            <table
                                style="width: 100%"
                                aria-label="Revenue-Based Annual Dues"
                            >
                                <tr>
                                    <th></th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <td style="width: 60%">
                                        Revenues > US $15B
                                    </td>
                                    <td style="width: 40%">$55,000</td>
                                </tr>
                                <tr>
                                    <td>Revenues US $5.0B - US $14.9B</td>
                                    <td>$50,000</td>
                                </tr>
                                <tr>
                                    <td>Revenues US $1.0B - US $4.9B</td>
                                    <td>$25,000</td>
                                </tr>
                                <tr>
                                    <td>Revenues US $500M - US $999M</td>
                                    <td>$15,000</td>
                                </tr>
                                <tr>
                                    <td>Revenues US $150M - US $499M</td>
                                    <td>$10,000</td>
                                </tr>
                                <tr>
                                    <td>Revenues US $50M - US $149M</td>
                                    <td>$5,000</td>
                                </tr>
                                <tr>
                                    <td>Revenues &lt; US $50M</td>
                                    <td>$2,000</td>
                                </tr>
                                <tr>
                                    <td>Non-profit entities</td>
                                    <td>$1,000</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="box-foot">
                    <button
                        type="button"
                        class="btn btn-default btn1"
                        @click="nextStep('FDX_MEMBER')"
                    >
                        BECOME AN FDX MEMBER
                    </button>
                </div>
            </div>
            <!-- <div class="box">
                <div class="box-head">Registrant (Available Fall 22)</div>
                <div class="para1">
                    For organizations interested in gaining access to the FDX
                    API specification & viewing and being listed on the FDX
                    registry.
                </div>
                <div class="box-body">
                    <div class="row">
                        <div class="col-sm-6 divide-line">
                            <p><strong>What’s Included</strong></p>
                            • Access to FDX API<br />
                            • Access to FDX material/documentation<br />
                            • Unlimited Users<br />
                            • Registry Viewing<br />
                            • Implementation Guides
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Cost</strong></p>
                            <p>Revenue-Based Annual Registry Fee</p>
                            <table
                                style="width: 100%"
                                aria-label="Revenue-Based Annual Dues"
                            >
                                <tr>
                                    <th></th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <td style="width: 60%">
                                        Revenues > US $50M
                                    </td>
                                    <td style="width: 40%">$55,000</td>
                                </tr>
                                <tr>
                                    <td>Revenues &lt; US $50M</td>
                                    <td>$2,000</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="box-foot">
                    <button
                        type="button"
                        class="btn btn-default btn1"
                        @click="nextStep('FDX_REGISTRANT')"
                    >
                        BECOME AN FDX REGISTRANT
                    </button>
                </div>
            </div> -->
            <div class="box">
                <div class="box-head">Observer</div>
                <div class="para1">
                    For organizations only interested in gaining access to the
                    FDX API specification.
                </div>
                <div class="box-body">
                    <div class="row">
                        <div class="col-sm-6 divide-line">
                            <p><strong>What’s Included</strong></p>
                            • Access to FDX API<br />
                            • Access to FDX material/documentation
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Cost</strong></p>
                            <p>FREE*</p>
                        </div>
                    </div>
                </div>
                <div class="box-foot">
                    <button
                        type="button"
                        class="btn btn-default btn1"
                        @click="nextStep('FDX_OBSERVER')"
                    >
                        BECOME AN FDX OBSERVER
                    </button>
                </div>
            </div>
            <div class="fine-print">
                *You can become an FDX Observer and access the FDX specification
                for Free by registering and accepting the FDX API License
                Agreement. As a FDX Observer, you will not have access to the
                FDX Registry, FDX member materials or artifacts, and you will
                not be able to attend access, or contribute to FDX working
                groups, task forces, events or any other forum activity.<br /><br />
                ** Please review FDX's Parent-Subsidiary Membership Policy, if
                your organization is a subsidiary or operates through one or
                more affiliated subsidiaries. Please contact us if you have any
                questions.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StartPage",
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    created() {

        this.$store.state.emailValid = null;
        this.$store.state.VerifyEmailResponse = null;
        this.$store.state.user = null;
        this.$store.state.abandonmentStatus = null;
        this.$store.state.ofacValid = null;
        this.$store.state.userOrgResponse = null;
        this.$store.state.organizationList = null;
        this.$store.state.domainsByOrganization = null;
        this.$store.state.docusignAccessToken = null;
        this.$store.state.docusignUserInfo = null;
        this.$store.state.pageState = null;
        this.$store.state.authcode = null;
        this.$store.state.Auth.user = null;
        this.$store.state.Auth.userRole = 'anonymous';
        this.$store.state.userToken = null;
    },
    methods: {
        nextStep(val) {
            if (this.$route.query.firstName) {
                this.$router.push({
                    name: "AccountView",
                    query: {
                        membershipType: val,
                        prefix: this.$route.query.prefix,
                        firstName: this.$route.query.firstName,
                        middleName: this.$route.query.middleName,
                        lastName: this.$route.query.lastName,
                        suffix: this.$route.query.suffix,
                        title: this.$route.query.title,
                    },
                });
            } else {
                this.$router.push({
                    name: "AccountView",
                    query: {
                        membershipType: val,
                    },
                });
            }
        },

        redirectToMainPage() {
            if (this.$store.state.Auth) {
                if (
                    JSON.parse(this.$store.state.Auth.user).memberType ===
                        "SUS" ||
                    JSON.parse(this.$store.state.Auth.user).memberType === "STD"
                ) {
                    window.open(
                        "https://financialdataexchange.org/" + "FDX/FDX/MemberHome.aspx",
                        "_self"
                    );
                } else {
                    window.open("https://financialdataexchange.org/" + "FDX/FDX/FDX_API.aspx", "_self");
                }
            }
            if (JSON.parse(this.$store.state.user).membershipType) {
                if (
                    JSON.parse(this.$store.state.user).membershipType ===
                    "FDX_MEMBER"
                ) {
                    window.open(
                        "https://financialdataexchange.org/" + "FDX/FDX/MemberHome.aspx",
                        "_self"
                    );
                } else {
                    window.open("https://financialdataexchange.org/" + "FDX/FDX/FDX_API.aspx", "_self");
                }
            }
        },
    },
};
</script>

<style scoped>
.container {
    box-sizing: border-box;
    max-width: 1123px;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}

.breadcrum {
    box-sizing: border-box;
    width: 100%;
}
.breadcrum .link {
    color: #019382;
    padding: 5px;
}

.heading {
    font-weight: 700;
    font-size: 29px;
    line-height: 34px;
    color: #1978a0;
}

hr {
    border: 2px solid #d8d8d8;
    width: 100%;
    margin: 0%;
}

.para1 {
    background: #f6f5f5;
    padding: 22px;
    width: 100%;
}

.para2 {
    font-style: italic;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}

p span {
    color: #019382;
}

.btn1 {
    background: #019382;
    border-radius: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    width: 319px;
    height: 45px;
    float: right;
}

.list-group-item {
    text-align: left;
    background: #f6f5f5;
    font-size: 16px;
    line-height: 19px;
    color: #5a7d95;
}

.list-group .active {
    background: #1978a0;
    color: #ffffff;
}

.box {
    border: 1px solid #d8d8d8;
    width: 100%;
    margin-top: 20px;
    padding-bottom: 15px;
}
.box-head {
    color: #ffffff;
    background: #4e697b;
    padding: 20px;
    font-weight: 700;
    font-size: 21px;
}
.box-body {
    border-top: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    padding: 10px;
    padding-left: 20px;
    width: 100%;
}
.box-foot {
    width: 100%;
    padding: 15px;
}
.tr {
    padding: 10px;
}
.fine-print {
    font-weight: 400;
    font-size: 12px;
}
.divide-line {
    border-right: 1px solid #d8d8d8;
}
@media (max-width: 768px) {
    .container {
      font-size: 14px !important;
    }
    .heading{
        font-weight: 600 !important;
        font-size: 23px !important;
        line-height: 28px !important;
    }
    .para1 {
        padding: 15px !important;
    }

    .box-head {
        font-size: 18px !important;
        padding: 15px 20px !important;
    }

    .box-body {
        padding: 10px !important;
    }

    .btn1 {
        width: 280px !important;
        margin-top: 10px !important;
    }
    .breadcrum {
        display: flex ;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
    }
    .breadcrum .link {
        margin-right: 5px;
    }
    .breadcrum a:last-child {
        margin-right: 0;
    }
    .container-content{
        margin:0px !important ;
      }
}

@media (max-width: 600px) {
    .container {
      font-size: 12px !important;
    }
    .btn1 {
        width: 260px !important;
        margin-top: 10px !important;

    }
    .heading{
        font-weight: 500 !important;
        font-size: 20px !important;
        line-height: 25px !important;
    }
    .para1 {
        padding: 12px !important;
    }
       .divide-line{
        border-right: none !important;
      }
}
</style>
